/**
 * Player development in the NBA is changing. A free, public article.
 *
 * Coleman's piece, verbatim. The only edits are obvious typos (ieas, sysytem,
 * difficutly, siply, respinsibility, geting, Llight, entires) and four
 * agreement slips. Nothing has been rewritten, tightened or reordered, and
 * where the source says something awkwardly it still says it awkwardly.
 *
 * ONE CHAPTER, on purpose: "just one long article". That has a consequence
 * worth knowing, because the reader's lead gate is `publicMode && active > 0`
 * (MasterclassReader.jsx): chapter one is always free, so a single-chapter
 * article never gates and captures no email. The ask is the `cta` block at the
 * end instead, which is where Coleman's own closing paragraph already points.
 * Splitting this in two is the only thing that turns the gate on.
 *
 * ── The clips ──────────────────────────────────────────────────────────────
 *
 * Twenty-seven, and every playback id below was read out of the `drills` table
 * rather than copied off a Mux screen. That is deliberate. The passing
 * masterclass shipped with nine dead clips because ids were read off the
 * Assets LIST, where an asset id and a playback id look identical and only one
 * of them plays. Reading the column removes the step where a human retypes a
 * 40-character string.
 *
 * Twenty-two live in the `article` collection: published, held, and listed on
 * no page anywhere (see constants/collections.js). They are fragments of this
 * argument, not drills a coach would browse to. Five are real library drills
 * that happened to be the right clip.
 *
 * No em dashes.
 */

export const NBA_PLAYER_DEV_KEY = "nba-player-development";

/**
 * Playback ids, with the drill title each one came from.
 *
 * An id here comes from the `drills` table, or from the Playback and
 * Thumbnails tab in Mux, or from Coleman as text. NEVER from the Assets list:
 * that page shows ASSET ids, which are the same shape and do not play.
 */
const V = {
  // Already in the library
  whatIsCla:        "FHQl2KTynWkFCwRIoxzzBRtxH8qVK8DYDNtu17vYXgw",   // What is, and What is NOT, the CLA?
  driveTendency:    "nXAOwvB5G5ZAmTC0002BzTDi7Hy84Gg7XDjBnzEIDUq9I", // 1v2 with Drive Tendency Constraint
  rotationalAway:   "xAkbz01G835TQH5Kt8Ei4x95ZhAnUFrsl4u0202102KhGOY", // Rotational Away From Rim Turn 3s
  pivotStart:       "rQHiuU77kRbjM5OhJwMUAl00OAfaHkt00bjl02Ehd02a6PI", // Pivot Start 1v2
  euroleague:       "O6Y00mVrrBW4jQdJ1Jva8NYGYCYAepaZd5O8yYzQWRDA",   // Off-Season Workout with EuroLeague Center

  // Held to the article collection
  jeffBackpedal:    "o38IXQn1VJeP3LIJuU927HH5zi4mQiyx3ujP5RZ4zPk",   // JEFF BACKPEDAL CONSTRAINT
  justinSmaller:    "O1rvf44jVFKqNDf7zhenQ013PG62vrxxqu163XnBZjVI",  // JUSTIN SMALLER SPACE
  nashJeff:         "ObEsZoSrAu01PCxPgFfa3RbHEqF2YN54LdQdwKaJ5g4s",  // NASH JEFF
  highSpeedTwoFoot: "fQkZ602le003Kqo8AYBb02OoROp4FQXaQmRcTDwJQCBBhE", // HIGH SPEED 2 FOOT
  beckPocketPulls:  "dVxQZQYuWd4JvjqcoC4SGgCzcPx4dUrDB3NdIIeIo8I",   // BECK WEAK HAND POCKET PULLS
  beckAudioCue:     "d4AJT8Bf9v7cXmOh4Z1aWzl99zQyb3tzvcrYzfmXr4c",   // BECK WEAK HAND POCKET PULLS AUDIO CUE
  maxHooper:        "DWPqTd3MzJgpkwZwHphuiGbzv8QlydxL64rc01vK3uPI",  // MAX HOOPER
  indConstraints:   "WLnMgqn01RVDI600cEjYPoPnrhnQYifSfta496Zj77uc8", // INDIVIDUAL CONSTRAINTS SESSION
  indConstraintsBigs:"UJFdOce98B2gUZGVyX35FnrfH3OPD7wV7TVViqVjvOU",  // INDIVIDUAL CONSTRAINTS BIGS
  variableFinish:   "whjYiYH02AEnhhkynb9RRalkqu6T2a2Nx8dfxJphZ9SY",  // VARIABLE FINISH CONSTRAINTS
  dropBingo:        "O6rDqsuAkxmie00J8j02i02U46SBePGDewQbhCI02lLoTY8", // DROP BINGO
  dhoReject:        "BwQx5zfgyweRj79KrrHbuGLMvlK38Y00Jxn9F6MRUUHs",  // DHO to Reject Bingo
  dunkerBingo:      "S9EpJ4F02A82qnmhFaBLQvhiFumowyMjPQqrcDk02bgMU", // DUNKER SPOT BINGO

  // The zoom progression, which renders as a swipeable deck
  zoom1:   "VR02lGWGDplRiLrs93C8xliE8W3MReeu85YHGGSUqGs00",
  zoom2:   "DIsqkMtF6C9sPE5jRtpSA1r01Ltx5SnP3PlWYPLPI5aw",
  zoom3:   "j8WH3GD2DPa0000HazvMujg7m3ckn7q02wpKudiOJT5Gq4",
  zoom4:   "52GRn3EYggEW2ksYcZQpPLTiba6WSVPxcf9jdrZ44wI",
  zoom5:   "opwd2kH00IKyo02kvGshFSoPnu01ncMs01w5wD1o8GMAvcM",
  zoom5_1: "ALyq8g1EfkXJ017Gm0101fuTT587t9asru41ypme700nOnI",
  zoom6:   "HsRqCS6OYfnqCwSSZvoWtDpSwNZezwxoD8Z0202grF1EY",
  zoom6_1: "mlPDw1415kPAEvbfzGhmL9w901T8mim3lJhJofcLOZ4w",
  zoom7:   "Uqsg012De000200LQ401EWxUIi802IaVYk1024BxEyUE01K2ab4",
};

export const NBA_PLAYER_DEV_MODULE = {
  key: NBA_PLAYER_DEV_KEY,
  title: "Player development in the NBA is changing",
  byline: "By Coleman Ayers",
  // The article layout, which is what this is. Without it the reader used
  // the card treatment: a "CHAPTER 1" label over a monospace gold pill, on
  // a 4,600 word piece with one chapter. The article layout drops the
  // chapter furniture, sets the meta in the body serif, and uses the
  // reading measure.
  layout: "article",
  sub: "Ten recommendations for using constraints and skill acquisition science in a pro setting, with the clips.",
  coverVideoId: V.whatIsCla,
  duration: "30 min read",
  chapters: [
    {
      title: "Player development in the NBA is changing",
      // The reader guesses a chapter's length from its first video, which
      // for an article that opens with a 3-minute clip reads "4 min watch"
      // over 4,600 words. An author who knows better says so.
      meta: "30 min read",
      blocks: [

        { kind: "text", md:
          "The CLA and skill acquisition science-informed methods are rapidly becoming more widely used in professional basketball." },

        { kind: "text", md:
          "Ironically, it does feel like the college and NBA worlds are the last to begin to adopt some of these new approaches and perspectives (conversation for another time), but either way, when that happens, it's safe to say that we'll see the changes trickle down and around to every realm of basketball, from youth, to high school, to college, to professional leagues outside of the US, to the average joe working on their game." },

        { kind: "text", md:
          "So, a shift in basketball coaching is without a doubt underway." },

        { kind: "text", md:
          "And it's our job to stay on the cutting edge of coaching, while simultaneously respecting all of the coaching that's come before these more \"innovative\" methods, because it's clear that (1) the stuff that's been used for decades clearly can work to a high degree, and (2), by attacking more traditional methods, we're only doing a disservice to the entire craft. Ultimately, both sides lean into defensiveness and conflict, rather than a state of curiosity, collaboration, and exploration, which should be our goal as coaches, if we're truly aligned that our sole purpose is to serve the player in front of us, right?" },

        { kind: "text", md:
          "I figured this article would help professional, aspiring professional, and college coaches around the world take the best approach to this exciting new wave of information and new ideas. We'll get super practical, but I want to first quickly note a few things. Give me three minutes." },

        { kind: "text", md:
          "First off, the Constraints-Led Approach is not what it's widely being made out to be, even by its biggest supporters." },

        { kind: "text", md:
          "We often throw everything new in a massive bucket with a \"CLA\" sticker on it, but the CLA is only a piece of a wider, science-informed lens to coaching that also includes, but isn't limited to, skill acquisition science, ecological dynamics, and frankly, a range of ideas that challenge the status quo of how coaches and players traditionally have thought about things." },

        { kind: "text", md:
          "I'll leave that for another time, but this 3-minute video is a very good start that I'd strongly suggest checking out!" },

        { kind: "video", muxPlaybackId: V.whatIsCla },

        { kind: "text", md:
          "This article will primarily discuss the use of constraints, but will also sample how to best use some of the core skill acquisition science concepts in the pro setting." },

        { kind: "text", md:
          "Second, constraints have been around forever, and exist in literally every area of life! I'd strongly recommend David Epstein's \"Inside the Box\" to understand this concept better and how you probably already use them in every area of life from coaching, to your relationship." },

        { kind: "text", md:
          "On the flip side, there is a growing belief that the CLA is simply traditional coaching rebranded and is nothing new at all, which I'd strongly disagree with, too. Just because an intuitive tool has been around for years doesn't mean it's been seen as a centerpiece to the craft of coaching, and used intentionally as a default method, which is where much of the results are actually unlocked." },

        { kind: "text", md:
          "And third, I'm not here to claim that this is the end-all-be-all way of doing things. I have zero \"agenda.\" I'm for whatever gets the players better, pushes the sport forward, keeps joy in the game, and builds up the human alongside the athlete. We've just found through relentless research and experimentation that this is a pretty damn good way to do that, from young players up to the 15-20 professional players we work with each off-season." },

        { kind: "text", md:
          "Nothing is to say that other methods, tools, and approaches don't work. But the goal should be to continue to find the 1% better, right?" },

        { kind: "text", md:
          "Hopefully you will be able to see all of this in action throughout this piece." },

        { kind: "text", md: "Now for the good stuff." },
        { kind: "rule" },

        { kind: "text", md:
          "I've spoken with coaches from around half of NBA teams (and heard about more) who are at least beginning to include the so-called \"CLA\" in their player development, if not making it the core pillar in how they do things." },

        { kind: "text", md:
          "Having seen this on the inside via consulting for teams, having long convos with coaches, working with players, and observing a ton, it's safe to say that certain teams are applying it very well, but many are still getting started and blindly jumping into it because other teams are. Which is a natural and healthy part of the innovation process!" },

        { kind: "text", md:
          "Overall, there's a long way to go understanding-wise. Right now, the average understanding of CLA and skill acq in the NBA setting is likely something around \"play more live basketball, make more decisions, throw in some variability,\" yet as someone who's dedicated their life to innovating how we coach and works with a wide variety of pros, I will say that many times, not using the CLA is better than uninformed or poorly-designed CLA." },

        { kind: "text", md:
          "But it's a start. And hopefully with more resources like these, the knowledge will quickly grow!" },

        { kind: "text", md:
          "Here are my overall recommendations to pro coaches to ensure these emerging approaches are used most effectively, for now, focusing on the player development side:" },

        /* ── 1 ───────────────────────────────────────────────────────────── */
        { kind: "heading", level: 2, text: "1: The Prerequisites" },

        { kind: "text", md: "The effectiveness of constraints relies on a few things:" },

        { kind: "text", md:
          "**1. Players want to win and solve the problem.** The use of Constraints for learning inherently relies on players wanting to \"win\" what you throw at them, because if they don't, it becomes mindless and the task isn't changed by the constraint, anyways." },

        { kind: "text", md:
          "For example, if you're playing a 1v1 finishing game where a right-left two-foot finish is 3 points, but they don't really care about winning (or it's too easy to win), they probably won't explore the right-left finish. Which means, realistically, you're better off just having them rep it out on-air." },

        { kind: "text", md:
          "Now, the good thing is that almost no one should have this problem, especially when coaching pros, who are often professionals because of how competitive they are. Are there days where guys come in flat and it's tough to get the level of competition up? Sure. Can you often find some way to prime up the competitive juices with an engaging game? Absolutely. Or, if their nervous system is super fried, at least start with more restoration and confidence-based work if absolutely needed and go from there." },

        { kind: "text", md:
          "However, it definitely does require building engaging games and drills with the right amount of difficulty." },

        { kind: "text", md:
          "If tasks are too easy, they'll check out and go back to what's comfortable. If it's too difficult, they (1) have no failure <-> success feedback loop to learn from but most importantly, (2) they'll check out here, too. Especially pros who are so used to succeeding 70%+ of the time in practice doing more repetition-driven training." },

        { kind: "text", md:
          "On top of that, there needs to be a culture of psychological safety built (even if it's a slow process), in which players understand that the success rate should not be as high as what they're likely used to, and that failure is an essential piece of improvement in the right doses. If they're constantly being held to a standard of perfection in training by you, their off-season trainer, or other coaches on staff, it's tough for them to fully immerse themselves in the level of difficulty that science demonstrates is required for learning." },

        { kind: "text", md:
          "We've definitely had some players who go through a rough adjustment process as their training success rate is cut in half, but we'll cover this later in the article." },

        { kind: "text", md:
          "**The second prerequisite is that players respect the constraints, and you provide immediate feedback when they don't.**" },

        { kind: "text", md:
          "We see something called \"constraint drift\" all the time, where coaches will set a constraint, but quickly allow players to disobey it, and it ruins the learning experience. Once you allow players to slip on the constraints, it's hard to ever reverse it. Especially pros. They love cheating to win and will try to argue you on everything. Don't be a yes-man!" },

        /* ── 2 ───────────────────────────────────────────────────────────── */
        { kind: "heading", level: 2, text: "2: Don't Think \"Drills\"" },

        { kind: "text", md:
          "Think less about what drills or games you're going to use, and more about solving problems for your players." },

        { kind: "text", md:
          "So often, we (even at the pro level) jump straight to what the drill should be. It's natural." },

        { kind: "text", md:
          "Eventually, you realize that the drill itself really doesn't matter at all. No drill is inherently bad or good." },

        { kind: "text", md:
          "Rather, it's about the learning experience for the players. The process should go as follows:" },

        // The source list came out of the PDF interleaved (its markers and
        // its text separated). Reconstructed in the only order the fragments
        // support. Numbered rather than ticked: the order is the point, and
        // nobody is working through a magazine article with a pencil.
        { kind: "text", md:
          "1. Take a look at their player development plan to remind yourself what the problems are that you need to help them solve. We organize this into the common situations they see\n"
          + "2. Set up a nice \"environment\" for them to do this. This could be a small-sided game, an on-air drill, or anywhere in between (e.g., guided defense, highly constrained defense, visual or cues)\n"
          + "3. Adjust it to get exactly what you want using the tools in your coaching toolbox, such as: more or less variability; incentivizing options they're struggling with or you want to see more of; restricting options they're comfortable with; limiting space; adding or taking away decisions\n"
          + "4. Ask yourself during the task: \"Are they working on the target skill/decisions with the right level of difficulty, and are they engaged in the task?\"\n"
          + "5. If not, adjust! It should be a living and breathing learning experience" },

        { kind: "text", md:
          "It's a common misconception that through the CLA, you simply set up a game and let them play. Instead, you may be adjusting the constraints as you go, coaching through the game, and more." },

        { kind: "text", md:
          "I've found this will often simplify the drills or games you strain your brain trying to come up with, and put more weight on the minor changes you make to them. Because rarely should the same \"drill\" be the same learning experience, anyways." },

        { kind: "text", md:
          "Plus, we want players to learn, not master drills." },

        /* ── 3 ───────────────────────────────────────────────────────────── */
        { kind: "heading", level: 2, text: "3: Be very intentional" },

        { kind: "text", md:
          "You can be more intentional with your games, constraints, and coaching. I know I always can, too." },

        { kind: "text", md:
          "As we discussed, boiling down the CLA and skill acq to \"more live defense and decision making\" doesn't do it anywhere near enough justice." },

        { kind: "text", md:
          "I visualize this part of being a coach like being in an airplane cockpit. We have a vast amount of buttons, levers, and switches that we can adjust to get exactly what we want out of a learning experience, and so many coaches have only explored the ones right in front of them, like \"you can't jump off of one foot,\" or \"you must shoot a three or a layup.\"" },

        { kind: "text", md:
          "That's a good start, but there are deeper layers to it, and it's a fun process once you start to get nice with it." },

        { kind: "text", md:
          "Here are just a few examples of intentional constraints that aren't rocket science at all, but create very specific learning experiences or force them to solve super targeted problems:" },

        { kind: "video", muxPlaybackId: V.driveTendency,
          title: "One of the big items on Dill's PDP was being too left-dominant on drives -> \"score left / drives left and counters to right = 0 points. score going right = 1 point. play to 5 points.\"" },

        { kind: "video", muxPlaybackId: V.jeffBackpedal,
          title: "I noticed too much of a drift backwards in Jeff's strategy shooting backwards, and he was short a lot -> \"don't land on me.\"" },

        { kind: "video", muxPlaybackId: V.justinSmaller,
          title: "I wanted tighter angles, more unpredictable and more jumpers to emerge -> \"let's narrow the space.\"" },

        { kind: "video", muxPlaybackId: V.nashJeff,
          title: "I wanted Jeff to explore the Nash dribble and keeping it alive more -> \"to win you must touch the opposite block before scoring.\"" },

        { kind: "video", muxPlaybackId: V.highSpeedTwoFoot,
          title: "I wanted to work on two-foot solutions but at higher speeds -> \"if you get tagged, no bucket.\"" },

        { kind: "text", md:
          "This doesn't just have to be in small-sided games / with live defense either!" },

        { kind: "video", muxPlaybackId: V.rotationalAway,
          title: "I wanted to work on Rayan's ability to control rotational AND backwards momentum -> \"start facing away from the rim, must land and quickly shoot it past the NBA 3.\"" },

        { kind: "video", muxPlaybackId: V.beckPocketPulls,
          title: "Beckett had a weird blind spot shooting threes going left when the ball was wide and behind -> \"Ball moves first, must go back & around this pole.\"" },

        { kind: "video", muxPlaybackId: V.beckAudioCue,
          title: "Then I realized it was more about the indecision -> \"If I say 'go,' you gotta put it down on the ground into one more quick dribble.\"" },

        { kind: "text", md:
          "Even out of a specific action, rather than just playing out of that action, you can identify \"pain points\" and attack those with constraints and drill design! This is a bit longer of a progression, but feel free to swipe through how we'd go a few layers deeper into building competency out of a zoom action." },

        // The carousel. `deck` is the house swipeable-card block, so the nine
        // fragments read as one progression rather than nine videos in a row.
        // No card titles. The header already reads "1 of 9", so a title of
        // "1" printed the number twice, once small in gold and once large in
        // bold directly beneath it.
        { kind: "deck", cards: [
          { blocks: [{ kind: "video", muxPlaybackId: V.zoom1 }] },
          { blocks: [{ kind: "video", muxPlaybackId: V.zoom2 }] },
          { blocks: [{ kind: "video", muxPlaybackId: V.zoom3 }] },
          { blocks: [{ kind: "video", muxPlaybackId: V.zoom4 }] },
          { blocks: [{ kind: "video", muxPlaybackId: V.zoom5 }] },
          { blocks: [{ kind: "video", muxPlaybackId: V.zoom5_1 }] },
          { blocks: [{ kind: "video", muxPlaybackId: V.zoom6 }] },
          { blocks: [{ kind: "video", muxPlaybackId: V.zoom6_1 }] },
          { blocks: [{ kind: "video", muxPlaybackId: V.zoom7 }] },
        ] },

        { kind: "text", md: "Even rotation systems affect this!" },
        { kind: "video", muxPlaybackId: V.maxHooper,
          title: "From our BAM Coaches Podcast Episode with Capital City Go-Go assistant Max Hooper." },

        { kind: "text", md:
          "Overall, just think more about how everything affects the learning experience. All of these are a wide variety of different-looking constraints that we must consider when building the learning environment intentionally. Even the start:" },
        { kind: "video", muxPlaybackId: V.pivotStart },

        { kind: "cta", mode: "public",
          label: "See the pro library",
          url: "https://platform.byanymeanscoaches.com/#/signup",
          note: "By the way, we have 100s of these in the pro library on the platform. If you're interested, check it out here!" },
        { kind: "cta", mode: "signedIn",
          label: "See the pro library",
          url: "https://platform.byanymeanscoaches.com/#/pro",
          note: "By the way, we have 100s of these in the pro library on the platform. If you're interested, check it out here!" },

        /* ── 4 ───────────────────────────────────────────────────────────── */
        { kind: "heading", level: 2, text: "4: Individual constraints" },

        { kind: "text", md:
          "For anyone who's working with multiple players at once, it can be tough to individualize the learning experience." },

        { kind: "video", muxPlaybackId: V.indConstraints,
          title: "Until you unlock individual constraints, or in other words, giving each player their own constraints and challenges so that, although they may all be doing the same drill or game from the naked eye, they're all getting different learning experiences." },

        { kind: "text", md:
          "This has changed so much for us, and with pros who often have very specific problems to solve and tools to sharpen, I'd argue that this is one of the biggest keys to developing buy-in from players and getting targeted results." },

        { kind: "video", muxPlaybackId: V.indConstraintsBigs,
          title: "You could even change the constraints from rep-to-rep (randomly), catering to each player's player development plan." },
        { kind: "video", muxPlaybackId: V.variableFinish },

        { kind: "text", md:
          "[Check out a full podcast on this here.](https://podcasts.apple.com/us/podcast/individualizing-group-workouts/id1604852096?i=1000766432957)" },

        /* ── 5 ───────────────────────────────────────────────────────────── */
        { kind: "heading", level: 2, text: "5: Volume to \"game-like\" ratio" },

        { kind: "text", md:
          "There have definitely been times where we've gone too far in the direction of representative practice where everything is game-like. Almost all of the time was spent on small-sided games, and very little on simple reps-based practice. In recent years, I've definitely found more of a balance." },

        { kind: "text", md:
          "Because nobody could ever argue according to science that reps aren't valuable. They are. It's just about maximizing both ends of the spectrum: quantity and quality. Can we find ways to get super high quality reps at a decent quantity (often comes down to drill design), and then can we also find creative ways to maximize the quality of high-quantity reps?" },

        { kind: "text", md:
          "The solution to this? Find simple ways to add in a bit of difficulty to high-volume practice! Visual challenges, light decisions, different passes, a bit of variability, divergent constraints (e.g, \"gotta shoot a slightly different shot every time\")." },

        { kind: "text", md:
          "Interleave this throughout more difficult, representative drills. Maybe they get after it in a small-sided game or two, and then we give them a 3 minute window where we get a ton of repetition (\"without repetition\") up on variable one-dribble shots from the corner. Then back to the representative practice." },

        { kind: "text", md:
          "Then, at the end of workouts, give the players 5-15 minutes to drive their own workout! If they want simple blocked reps, they get it. If they want to add in a bit of variability but still favor high reps, cool. If they want game-winner 1v1, then we'll go with that. This is big for buy-in, to understand what drives each athlete, and often to fill in gaps that we haven't yet as a coach." },

        { kind: "text", md: "This balance makes a big difference." },

        /* ── 6 ───────────────────────────────────────────────────────────── */
        { kind: "heading", level: 2, text: "6: Know how to ease players into it" },

        { kind: "text", md:
          "I've talked to heaps of coaches who say things like, \"Well, pros are just used to the traditional stuff, so it's tough to innovate how they train.\"" },

        { kind: "text", md:
          "I think that's a bit of a cop-out sometimes. Pros love competing. They love solving problems." },

        { kind: "text", md:
          "Of course, some are conditioned to be more regimented and routine-based, and some want more \"feel good,\" confidence-heavy work. Cool. That's OK. Everyone's wired differently, and some have definitely been conditioned by past training to favor a more high-feedback learning experience rather than being challenged to figure it out." },

        { kind: "text", md:
          "But I truly believe that there's no way players can enjoy playing the game of basketball, without enjoying this style of training. It just takes framing it the right way at first, meeting them halfway early on, and easing them into it sometimes. And I've yet to come across a player who I haven't cracked the code with and built buy in to explore these new methods." },

        { kind: "text", md:
          "This relies on a few things, starting with finding a good order to introduce it:" },

        { kind: "text", md:
          "If I'm working with a new player, it could go one of two ways." },

        { kind: "text", md:
          "With vets who express being more regimented, it may start off with more traditional training, mixed in with small constraints or light reaction that meet them a bit halfway. Depending on the vibes they give, it may take minutes or weeks to progress up to more, but bit by bit, we add." },

        { kind: "text", md:
          "For most younger players, we'll get straight into a reactive warmup (which, by the way, is a great time to innovate and get a bit out of the box), and then will jump into a nice game out of an action they'll see a lot or a shot they'll get a ton. This intuitively makes sense to them 99% of the time: it's not unreasonable for training to include playing out of commonly-seen actions." },

        { kind: "text", md:
          "I love bingo games for this, as I've always found pros respond very well to it, and it's a nice mix of a divergent constraint disguised in a simple competitive environment" },

        { kind: "video", muxPlaybackId: V.dropBingo },
        { kind: "video", muxPlaybackId: V.dhoReject,
          title: "Here, Nate had to solve this DHO -> ball screen in four different ways: spin vs. the high switch into a mid range, spin vs. high switch into three, snatch back three, and find a way to use the screen into a jumper. Notice how he got to the end and only had one to check off, and goes through a nice problem-solving process that creates a lot of focus and laughter." },
        { kind: "video", muxPlaybackId: V.dunkerBingo },

        { kind: "text", md:
          "Then comes the art of coaching. Read the vibes. See if they're enjoying it, holding back, opening up, or really starting to compete, and respond accordingly." },

        { kind: "text", md:
          "You can start to add in very general, more intuitive constraints (e.g., \"you gotta find X type of shot\"), and then progress up to more layered, intentional ones like the ones above" },

        { kind: "text", md:
          "In terms of shooting work, the progression will look somewhat like this:" },

        { kind: "text", md:
          "- **Light variability:** just moving spots a bit more, rotating through shots, different passes.\n"
          + "- **Anchor shooting:** tougher dynamic entries to the shot where they're meant to find a stable, consistent release, but may be challenged in doing that.\n"
          + "- **Stress shooting:** challenging their ability with defenders, decisions, fatigue, and more external constraints.\n"
          + "- **Exploration shooting:** shots where they're purposefully exploring different techniques, like staggered footworks, drifts, and more. This tends to get the craziest reaction from many technique-driven shooters, but is also very intuitive and fun to other players." },

        { kind: "text", md:
          "Considering the amount of feedback they get is important here, too. We know that for us to build better learners and more robust skill, we often shouldn't rely on high amounts of feedback, but some players are so used to getting the answer given to them that we may need to be more vocal at first, and work up to them learning more autonomously as the game and drill design is what does the trick, while we hold our punches coaching-wise and force them to \"figure it out\" more often." },

        { kind: "text", md:
          "And much of this will come down to having quality dialogue with players before and after sessions." },

        { kind: "text", md:
          "For example, this summer I spoke with multiple players highlighting the disparity in their practice percentage (70-80% success) and game percentage (~40%), and talking through it from a logical standpoint. They asked questions, I'd often respond with questions, but eventually, it made sense to them: if I really want to learn, I must make training harder or as hard as the game, and thus, I need to fail more in training." },

        { kind: "text", md:
          "How am I gonna fail more in training? Defenders. Decisions. Sometimes, some crazy shots. And we even do workouts where my goal is to get them below 45%, and they can win the workout by beating that number. And with this framing, it makes more sense when I throw some crazy shit at them!" },

        { kind: "text", md:
          "- \"Why I don't give you a ton of feedback when you're struggling.\"\n"
          + "- \"Why we switch up shots so much from rep to rep.\"\n"
          + "- \"Why are some things we do non-game-like?\"" },

        { kind: "text", md:
          "These conversations are some of my favorite times with players, not only because it challenges me as a coach to simplify and articulate these ideas better, but because players are changing their mental models of what skill is and how to develop it, which can make a massive imprint on them and their career." },

        { kind: "video", muxPlaybackId: V.euroleague,
          title: "Tonye here came in this past summer having never had a trainer, just doing very traditional workout with teams in the past. We started very basic and traditional, but over the course of the first few weeks, this is what we worked up to!" },

        /* ── 7 ───────────────────────────────────────────────────────────── */
        { kind: "heading", level: 2, text: "7: Engrain it into your culture" },

        { kind: "text", md:
          "When you look at the core of what the Constraints Led Approach is designed to build, at its core, it's about creativity, problem solving, and adaptability." },

        { kind: "text", md:
          "I combine all of these into one quality that I call \"figure-it-outability,\" which has become a mantra with our players and coaches, not just in basketball, but outside of it." },

        { kind: "text", md:
          "And when the training your players do every day is designed to become elite at adapting and \"finding a way,\" you'd be stupid not to make this into a core part of the team identity." },

        { kind: "text", md:
          "I'd say the same thing about joy, too, which the CLA often restores in players no matter their age, background, or past history, and it creates a low-hanging way to weave this into the team's style of play and approach to the game." },

        /* ── 8 ───────────────────────────────────────────────────────────── */
        { kind: "heading", level: 2, text: "8: Load management can make this tough. Get creative." },

        { kind: "text", md:
          "I've spent long hours talking about this one with pro and college coaches, who have medical teams on their ass about intensity and time on the court." },

        { kind: "text", md:
          "And while it'd be magical if we can get after it day in and day out, we can't. But this is a constraint on us as coaches, which, rather than turning us away from the CLA, should simply boost our ability to \"find a way\" to make it work effectively!" },

        { kind: "text", md: "Thankfully, there are plenty of ways to get around this." },

        { kind: "text", md:
          "- Smaller-space games.\n"
          + "- On-air CLA drills.\n"
          + "- Shadow defense/sparring.\n"
          + "- Limited movement, high cognitive load." },

        { kind: "text", md:
          "In fact, I'd argue that in a more reps-based view of training, we're more constrained by load management because if there's a direct correlation between reps and learning, then there's a direct correlation between time on court and learning." },

        { kind: "text", md:
          "Using these more modern coaching tools, we can find ways to maximize each rep, even if they're not very intensive on the body. Embrace that and spend time pondering how you can maximize quality." },

        /* ── 9 ───────────────────────────────────────────────────────────── */
        { kind: "heading", level: 2, text: "9: Periodize!" },

        { kind: "text", md:
          "Ask your athletic performance team how much time goes into periodizing the training to ensure athletes develop certain qualities before others, peak at the right time, undulate opposing qualities, and more." },

        { kind: "text", md:
          "Yet by default, we rarely do that on the court. Training often looks the same from off-season to post-season." },

        { kind: "text", md:
          "Here's a quick rundown of how different variables should change throughout the year." },

        // The source is a two-column table. `compare` is the house two-column
        // block, so each row's variable leads its item and the two sides stay
        // in the same order.
        { kind: "compare",
          leftTitle: "Further from season",
          leftItems: [
            "**Starts.** More random, less game-specific, challenge broader qualities like speed, balance, vestibular control",
            "**Tactical specificity.** Lower. You can expose players to situations outside their normal role",
            "**Constraint direction.** More divergent: encourage multiple solutions, exploration, variability",
            "**Technical focus.** More room for actual technique change: shooting mechanics, movement patterns, passing technique",
            "**Point systems.** Reward weaknesses / new solutions to encourage exploration",
            "**Rotation systems.** Lower stakes: rotate automatically, don't necessarily keep score, reduce pressure to fall back on strengths",
            "**Variability.** Higher. More different movement problems, starts, solutions, environments",
            "**Representativeness.** Can be intentionally less representative to broaden adaptability",
            "**Goal of training.** Expand the player's solution space",
            "**Weakness vs. strength bias.** Bias toward developing weaknesses",
          ],
          rightTitle: "Closer to / in season",
          rightItems: [
            "**Starts.** More representative of the exact situations the player will see in games",
            "**Tactical specificity.** Higher. Recreate common actions, coverages, rotations, catches, reads",
            "**Constraint direction.** More convergent: steer players toward the solutions you want showing up in games",
            "**Technical focus.** Less major technical reconstruction. Optimize and stabilize what they already have",
            "**Point systems.** Reward strengths / preferred game solutions to reinforce performance",
            "**Rotation systems.** Higher stakes: make-it-take-it / winning matters, which naturally pushes players toward reliable attractors",
            "**Variability.** Lower / more targeted. Variability still exists, but inside game-relevant boundaries",
            "**Representativeness.** Should become increasingly representative of actual game information and situations",
            "**Goal of training.** Optimize the player's current game",
            "**Weakness vs. strength bias.** Bias toward exploiting strengths",
          ],
        },

        /* ── 10 ──────────────────────────────────────────────────────────── */
        { kind: "heading", level: 2, text: "10: Develop an understanding, and know the science." },

        { kind: "text", md: "I'll keep this one short." },

        { kind: "text", md:
          "Just spend the time to understand the concepts, science, and principles behind the methods you use." },

        { kind: "text", md:
          "To be completely honest, I don't believe 90+% of pro coaches truly grasp the real science and logic behind these methods past a superficial level. That's ok as a starting point, but you have the responsibility to learn, even if you don't go fully nerd-out about it." },

        { kind: "text", md:
          "Trust me, I know it's not as fun as the X's and O's or actually being on the court, but understanding the concepts exponentially boosts your ability to solve specific problems, explain the \"why\" to players, build long-term plans, put your own flare on it, and add your own contributions to the craft, not just copying what others do." },

        { kind: "text", md:
          "And in fact, for most coaches, when they understand the research and scientific concepts on a thorough level, they end up becoming less polarized to one end of the \"spectrum\" between more traditional training and more brand-new, \"unique\" training, and end up finding a balance they feel increasingly comfortable with. Which I damn sure have over the past years." },

        { kind: "text", md:
          "If you're interested developing a deeper understanding or working with us, shoot me a DM on Instagram, sign up for the Coaches Platform, or check out Deep Skill and The Modern Basketball Blueprint, the two books I've written on a balanced approach to modern player development!" },

        { kind: "image", images: [
          { src: "/deep%20skill%20coaches%20platform.png",
            alt: "Deep Skill",
            href: "https://byanymeanscoaches.com/deep-skill",
            caption: "Deep Skill" },
          { src: "/modern%20basketball%20blueprint%20coaches%20platform.png",
            alt: "The Modern Basketball Blueprint",
            href: "https://byanymeanscoaches.com/blueprint-book",
            caption: "The Modern Basketball Blueprint" },
        ] },

        { kind: "cta", mode: "public",
          label: "Sign up for the Coaches Platform",
          url: "https://platform.byanymeanscoaches.com/#/signup",
          note: "The full drill library, the pro collection this article pulls from, the rest of the masterclasses, the practice plan and playbook builders, and a community of coaches working on the same problems you are." },
      ],
    },
  ],
};

export default NBA_PLAYER_DEV_MODULE;
